import React from "react";
import { Card, Typography, Row, Col, Button } from "antd";
import { MapContainer, TileLayer, Marker } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { Icon } from "leaflet";
import CreateJobServices from "../../../../services/createJob.services";
import {
  addressDetailsTitles,
  customerDetailsTitles,
  headers,
  jobDetailsTitles,
  projectInformationStatus,
  taxExemptCertificate,
} from "./constants";
import styles from "./ViewJobLead.module.scss";
import { MapConstants } from "../../../../constants/MapConstants";
import { FitBoundsSingle } from "../../../../utils/fitMarkerBounds";

const ViewJobLead = ({ jobLeadData }) => {
  const { Title, Text } = Typography;
  const { jobDetails, customerDetails, addressDetails, notes } = headers;
  const { jobName, salesPerson, projectInfoSheet, taxExemptStatus } =
    jobDetailsTitles;
  const {
    GOOGLE_SATILLITE_TILE_LAYER_URL,
    GOOGLE_MAP_ATTRIBUTION,
    GOOGLE_TILE_SUBDOMAIN_ARRAY
  } = MapConstants;
  const { customerAccount, onSiteContact, contactNumber, email } =
    customerDetailsTitles;
  const { jobSiteAddress, jobSiteCoordinates } = addressDetailsTitles;
  const createCustomIcon = (L, jobNumber, colorCode) => {
    return L.divIcon({
      className: "custom-marker-icon",
      html:
        "<div class='naviconmapss' style='color: " +
        colorCode +
        "; border: 1px solid " +
        colorCode +
        "; border-radius: 30px; padding:15px;width:100%;height:100%'>" +
        "<i class='fas fa-map-marker'></i>" +
        "<div class='truckid'>" +
        "<p>" +
        jobNumber +
        "</p>" +
        "</div>" +
        "</div>",
    });
  };
  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <h4 className={styles.cardTitle}>{jobDetails}</h4>
        <div className={styles.detailsSection}>
          <div className={styles.detailItem}>
            <span className={styles.label}>{jobName}</span>{" "}
            <span className={styles.value}>{jobLeadData?.jobName}</span>
          </div>
          <div className={styles.detailItem}>
            <span className={styles.label}>{salesPerson}</span>{" "}
            <span className={styles.value}>{jobLeadData?.salesPerson}</span>
          </div>
          <div className={styles.detailItem}>
            <span className={styles.label}>{projectInfoSheet}</span>{" "}
            <span className={styles.value}>
              {projectInformationStatus[jobLeadData?.projectInformationSheet] ??
                ""}
            </span>
          </div>
          <div className={styles.detailItem}>
            <span className={styles.label}>{taxExemptStatus}</span>{" "}
            <span className={styles.value}>
              {taxExemptCertificate[jobLeadData?.taxExempt] ?? ""}
            </span>
          </div>
        </div>

        <h5 className={styles.cardTitle}>{customerDetails}</h5>
        <div className={styles.detailsSection}>
          <div className={styles.detailItem}>
            <span className={styles.label}>{customerAccount}</span>{" "}
            <span className={styles.value}>
              {jobLeadData?.companyDetails?.company}
            </span>
          </div>
          <div className={styles.detailItem}>
            <span className={styles.label}>{onSiteContact}</span>{" "}
            <span className={styles.value}>
              {jobLeadData?.approvalInfo?.name}
            </span>
          </div>
          <div className={styles.detailItem}>
            <span className={styles.label}>{contactNumber}</span>{" "}
            <span className={styles.value}>
              {jobLeadData?.approvalInfo?.phone}
            </span>
          </div>
          <div className={styles.detailItem}>
            <span className={styles.label}>{email}</span>{" "}
            <span className={styles.value}>
              {jobLeadData?.approvalInfo?.email}
            </span>
          </div>
        </div>

        <h5 className={styles.cardTitle}>{addressDetails}</h5>
        <div className={styles.detailsSection}>
          <div className={styles.detailItem}>
            <span className={styles.label}>{jobSiteAddress}</span>{" "}
            <span className={styles.value}>{jobLeadData?.dropoff}</span>
          </div>
          <div className={styles.detailItem}>
            <span className={styles.label}>{jobSiteCoordinates}</span>{" "}
            <span className={styles.value}>
              {jobLeadData?.dropOffLatLng?.lng}° N,{" "}
              {jobLeadData?.dropOffLatLng?.lat}° W
            </span>
          </div>
        </div>

        <h5 className={styles.cardTitle}>{notes}</h5>
        <span className={styles.notesText}>{jobLeadData?.notes}</span>
      </div>

      <div className={styles.card}>
        <div className={styles.mapContainer}>
          <MapContainer
            center={[
              jobLeadData?.dropOffLatLng?.lat ?? 0,
              jobLeadData?.dropOffLatLng?.lng ?? 0,
            ]}
            zoom={15}
            className={styles.map}
          >
            <TileLayer
              attribution={GOOGLE_MAP_ATTRIBUTION}
              url={GOOGLE_SATILLITE_TILE_LAYER_URL}
              subdomains={GOOGLE_TILE_SUBDOMAIN_ARRAY}
            />
            <Marker
              position={[
                jobLeadData?.dropOffLatLng?.lat ?? 0,
                jobLeadData?.dropOffLatLng?.lng ?? 0,
              ]}
              icon={createCustomIcon(L, jobLeadData?.jobNumber, "#000000")}
              zIndexOffset={1000}
            />
            <FitBoundsSingle 
              latitude={jobLeadData?.dropOffLatLng?.lat}
              longitude={jobLeadData?.dropOffLatLng?.lng}
            />
          </MapContainer>
        </div>
      </div>
    </div>
  );
};

export default ViewJobLead;
